var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThread = function SvgThread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.723,
    fill: "#637381",
    rx: 6.957
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thread_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.968 20.312a6 6 0 0 0-.21-.095c-.123-2.276-1.366-3.578-3.454-3.592h-.029c-1.248 0-2.287.533-2.926 1.503l1.148.788c.477-.725 1.227-.88 1.779-.88h.019c.687.005 1.206.205 1.542.595q.367.427.489 1.17a8.8 8.8 0 0 0-1.974-.094c-1.985.114-3.26 1.272-3.175 2.88.043.817.45 1.518 1.144 1.977.588.388 1.344.577 2.13.534 1.038-.056 1.853-.453 2.42-1.177.432-.55.705-1.263.826-2.16.495.298.861.69 1.064 1.163.344.803.364 2.123-.712 3.198-.944.942-2.078 1.35-3.791 1.363-1.9-.014-3.338-.624-4.273-1.812-.875-1.113-1.327-2.72-1.344-4.776.017-2.057.469-3.664 1.344-4.777.935-1.188 2.372-1.798 4.273-1.812 1.915.014 3.377.627 4.348 1.82.475.586.834 1.323 1.07 2.181l1.346-.359c-.287-1.057-.738-1.967-1.351-2.722-1.244-1.531-3.064-2.315-5.408-2.331h-.01c-2.34.016-4.139.803-5.347 2.34-1.076 1.367-1.63 3.27-1.65 5.654v.011c.02 2.385.574 4.287 1.65 5.655 1.208 1.536 3.008 2.323 5.347 2.34h.01c2.08-.015 3.546-.56 4.754-1.766 1.58-1.579 1.532-3.558 1.012-4.773-.374-.87-1.087-1.579-2.06-2.046m-3.591 3.377c-.87.049-1.774-.342-1.819-1.178-.033-.62.442-1.312 1.872-1.395q.246-.014.483-.014a6.8 6.8 0 0 1 1.447.147c-.165 2.059-1.131 2.393-1.983 2.44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thread_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.174 12.897h16v16h-16z"
  })))));
};
export default SvgThread;